var $ = jQuery.noConflict();

$(window).on("load", function () {
  let method = "front";
  if ($("body").hasClass("wp-admin")) method = "wp-admin";

  // flag to prevent duplicated initialization (in editor)
  let initialized = false;

  var initializeBlock = function ($block) {
    if (initialized) return;
    // Place for your code
    if (method === "wp-admin") {
      console.log("init step-slider");
    }

    const $$ = (s, context = document) => {
      return Array.from(context.querySelectorAll(s));
    };

    $$(".block-step-slider").forEach((slider) => {
      const steps = $$(".block-step-slider__step", slider);
      const images = $$(".block-step-slider__img", slider);
      let currentActive;
      const delay = 5000;
      let timeoutID;

      slider.style.setProperty("--step-slider-delay", delay + "ms");

      const setActive = (index) => {
        steps.forEach((el) => {
          el.classList.remove("active");
        });
        steps[index]?.classList.add("active");

        images.forEach((el) => {
          el.classList.remove("active");
        });
        images[index]?.classList.add("active");

        currentActive = index;
        const nextActive = index < steps.length - 1 ? index + 1 : 0;

        if (timeoutID) {
          clearTimeout(timeoutID);
        }
        timeoutID = setTimeout(() => {
          setActive(nextActive);
        }, delay);
      };

      steps.forEach((element, index) => {
        element.addEventListener("click", () => {
          setActive(index);
        });
      });

      // set active after timeout -> otherwise transition will be skipped
      setTimeout(() => {
        setActive(0);
      }, 10);
    });

    initialized = true;
  };

  window.onload = (function () {
    initializeBlock($(this));
  })();

  if (window.acf) {
    window.acf.addAction(
      "render_block_preview/type=step-slider",
      initializeBlock
    );
  }
});
